/**
 * Created by carlos on 23/10/2024.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('revenueProductionSsrService', revenueProductionSsrService);

    revenueProductionSsrService.$inject = ['$http', 'CONFIG', 'messageService'];

    function revenueProductionSsrService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API ;
        var service = {
            updateSegmentItinerariesSsr: updateSegmentItinerariesSsr
        }

        return service;

        function updateSegmentItinerariesSsr(segmentItineraries){
            return $http.put(urlBase + "/segmentFlightSsr/updateAll" , segmentItineraries)
                .then(function(response){
                    messageService.registerUpdate('');
                    return "ok";
                })
                .catch(function(error){
                    messageService.registerUpdateError('');
                    return "error";
                });
        }
    }

})();

